import { type FC, useEffect, useState } from "react";
import { type DragDropSettingsProps } from "../../DragDropTypes";

export const DragDropImageWidthChecker: FC<DragDropSettingsProps> = ({ value }) => {
    const [ width, setWidth ] = useState(0);

    useEffect(() => {
        if(typeof value !== "string") {
            return;
        }

        const img = document.createElement("img");

        img.src = value;

        const listener = () => {
            setWidth(img.width);
        };

        img.addEventListener("load", listener);

        return () => {
            img.removeEventListener("load", listener);
            img.remove();
        };
    }, [ value ]);

    if(width > 600) {
        return (
            <p className="p-2 bg-orange-300">
                The image selected is larger than 600px wide, some
                email clients such as Microsoft Outlook may display this incorrectly
            </p>
        );
    }

    return null;
};
